import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'
import { Invoice, Payment } from 'types'

/**
 * Type Interface for the Response object you get from getSingleInvoice request if successful
 */
export interface getSingleInvoiceResponse {
	invoice: Invoice
	payments: Payment[] | []
}

export const getSingleInvoice = async (id: string) => {
	try {
		const { data } = await axios.get<getSingleInvoiceResponse>(
			`client/bill/invoice/${id}`
		)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default getSingleInvoice
